/* DN: Pfeil-Buttons (prev/next) fuer horizontal scrollende media-blocks-Sektionen
   (z.B. "Unsere Rituale"). Bindet jeden .dn-mb-arrow[aria-controls] an seinen
   Scroll-Container und scrollt um ~eine Sichtbreite; deaktiviert an den Raendern.
   Hinweis: native smooth-scrollBy/scroll-behavior:smooth ist auf diesem
   Grid-Container ein No-Op -> wir scrollen direkt (instant). */
(function () {
  function init() {
    var arrows = document.querySelectorAll('.dn-mb-arrow[aria-controls]');
    Array.prototype.forEach.call(arrows, function (btn) {
      if (btn.dataset.dnMbBound) return;
      var root = document.getElementById(btn.getAttribute('aria-controls'));
      if (!root) return;
      btn.dataset.dnMbBound = '1';

      btn.addEventListener('click', function () {
        var amount = Math.max(root.clientWidth * 0.8, 280);
        var dir = btn.getAttribute('data-dn-mb-dir');
        root.scrollBy({ left: dir === 'next' ? amount : -amount });
      });

      var update = function () {
        var max = root.scrollWidth - root.clientWidth - 2;
        var dir = btn.getAttribute('data-dn-mb-dir');
        btn.disabled = dir === 'prev' ? root.scrollLeft <= 2 : root.scrollLeft >= max;
      };
      root.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
